import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var VkIcon = function VkIcon() {
  return _jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.31615 0H15.6839C22.4079 0 24 1.59209 24 8.31615V15.6838C24 22.4079 22.4079 24 15.6839 24H8.31615C1.59209 24 0 22.4079 0 15.6838V8.31615C0 1.59209 1.59209 0 8.31615 0Z",
      fill: "#4680C2"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.6161 7.66055C19.7346 7.28795 19.6161 7.01695 19.091 7.01695H17.3465C16.9061 7.01695 16.7029 7.25405 16.5843 7.50815C16.5843 7.50815 15.6866 9.6761 14.4333 11.0819C14.0268 11.4883 13.8405 11.6238 13.6203 11.6238C13.5017 11.6238 13.3493 11.4883 13.3493 11.1157V7.6436C13.3493 7.20325 13.2138 7 12.8412 7H10.0974C9.8264 7 9.65705 7.20325 9.65705 7.4065C9.65705 7.82995 10.2837 7.93155 10.3514 9.11715V11.6916C10.3514 12.2505 10.2498 12.3521 10.0296 12.3521C9.43685 12.3521 7.9972 10.1672 7.1334 7.6775C6.964 7.1863 6.79465 7 6.3543 7H4.5928C4.08469 7 4 7.23715 4 7.4912C4 7.9485 4.5928 10.252 6.76075 13.3007C8.20045 15.3839 10.2498 16.5017 12.096 16.5017C13.2138 16.5017 13.3493 16.2477 13.3493 15.8243V14.2491C13.3493 13.741 13.4509 13.6564 13.8066 13.6564C14.0607 13.6564 14.518 13.7918 15.5511 14.7911C16.7367 15.9767 16.94 16.5187 17.6005 16.5187H19.3451C19.8532 16.5187 20.0903 16.2647 19.9548 15.7734C19.8024 15.2823 19.2265 14.571 18.4813 13.7241C18.0748 13.2499 17.465 12.7248 17.2787 12.4707C17.0247 12.132 17.0924 11.9965 17.2787 11.6916C17.2618 11.6916 19.3959 8.6768 19.6161 7.66055Z",
      fill: "white"
    })]
  }));
};

export default VkIcon;